angular.module('bookingApp')
    .controller('baseController', function ($scope, propertyFactory, sessionFactory, appFactory, extrasFactory, $location, $swipe, cartFactory, $routeParams, $http, $window, $timeout, $q, $document, $interval, $filter) {
        $scope.property = propertyFactory;
        $scope.session = sessionFactory;
        $scope.cart = cartFactory;
        $scope.baseApp = appFactory;
        $scope.extras = extrasFactory;

        $scope.roomsFilterHref = roomsFilterHref;
        $scope.logError = logError;
        $scope.setupStandardCartFooter = setupStandardCartFooter;
        $scope.goBack = goBack;
        $scope.goToPage = goToPage;
        $scope.goToCart = goToCart;
        $scope.reloadApp = reloadApp;
        $scope.goToRooms = goToRooms;
        $scope.safeApply = safeApply;
        $scope.showError = showError;
        $scope.showToast = showToast;
        $scope.checkPax = checkPax;
        $scope.triggerAdWords = triggerAdWords;
        $scope.checkSelectedRoomsAreAvailable = checkSelectedRoomsAreAvailable;
        $scope.getBookableReservationDetails = getBookableReservationDetails;
        $scope.getBookingLevelExtras = getBookingLevelExtras;
        $scope.getRoomExtrasTotal = getRoomExtrasTotal;
        $scope.getRoomInCartPrice = getRoomInCartPrice;
        $scope.getRoomInclExtrasTotal = getRoomInclExtrasTotal;
        $scope.removeRoom = removeRoom;
        $scope.triggerConfirmationTracking = triggerConfirmationTracking;
        $scope.triggerTrackingPageView = triggerTrackingPageView;
        $scope.getCartRoomTotal = getCartRoomTotal;
        $scope.setupItemOnlyFooter = function(){
            // setup functionality
            $scope.footer.prevFunc = function(){
                $scope.goBack();
            };
            $scope.footer.mainFunc = function(){
                $scope.goToPage('cart');
            };
            // set display settings
            $scope.footer.display = {prev: true, main: true, next: true};
            // setup the cart html
            $scope.footer.mainContent = '<span class="badge cart-count"><span class="glyphicon glyphicon-shopping-cart"></span>'+$scope.cart.bookingExtras.selected.length+'</span> Items in cart';
            // disable the next button if the cart is empty
            if($scope.cart.bookingExtras.selected.length <= 0){
                $scope.footer.disabled.next = true;
            }
        };

        $scope.loadExternalScript = function(src){
            var element = document.createElement('script');
            element.src = src;
            document.body.appendChild(element);
        };

        $scope.$watch('cart.insurance.chosen', function(){
            if($scope.cart.insurance.chosen !== null) {
                var url = '';
                if ($scope.cart.insurance.chosen) {
                    url = '/front-booking/add-insurance';
                } else {
                    url = '/front-booking/remove-insurance';
                }
                sessionFactory.isLoading = true;
                $http.post(url, {
                    sid: sessionFactory.sid,
                    format: 'json'
                }).success(function (data, status, headers, config) {
                    sessionFactory.isLoading = false;
                    if(data.valid) {
                        $scope.cart.insurance.amount = data.totals.insurance;
                        $scope.session.suggestedDeposit = data.totals.deposit;
                        // deposit & full amount
                    } else {
                        $scope.cart.insurance.chosen = null;
                        showError('Cannot add insurance', 'There was an error adding insurance to your booking - please contact the agent', true);
                    }
                }).error(function (data, status, headers, config) {
                    sessionFactory.isLoading = false;
                    // show error to the user
                    showError('Cannot add insurance', 'There was an error adding insurance to your booking - please contact the agent', true);
                });
            }
        });

        // footers controls / details setup
        $scope.footer = {
            nextFunc: nextFunc,
            prevFunc: prevFunc,
            mainFunc: mainFunc,
            display: {
                prev: false,
                main: true,
                next: false
            },
            disabled: {
                prev: false,
                main: false,
                next: false
            },
            prevGlyph: 'chevron-left',
            nextGlyph: 'chevron-right',
            mainContent: '<strong>Next <span class="glyphicon glyphicon-chevron-right"></span></strong>'
        };

        $scope.resetInsurance = function(){
            if($scope.cart.insurance.chosen !== null){
                $scope.cart.insurance.chosen = false;
            }
        };

        $scope.propertyOffersInsurance = function(){
            // check if the insurance widget should show
            if(!$scope.property.offersInsurance){
                $scope.resetInsurance();
                return false;
            }
            // ensure dob is within range
            var dob = moment($scope.session.booking.leadGuest.dob);
            if(
                moment().subtract($scope.property.insuranceCoverMinAge,'years').isBefore(dob) ||
                moment().subtract($scope.property.insuranceCoverMaxAge, 'years').isAfter(dob)
            ){
                $scope.resetInsurance();
                // display message to user
                $scope.property.insuranceErrorMessage = "You must be between 18 and 85 years to purchase insurance.";
                $scope.property.showInsuranceError = true;
                // return false;
            } else {
                $scope.property.showInsuranceError = false;
                $scope.property.insuranceErrorMessage = "";
            }
            // booking must have rooms to check against
            if($scope.cart.rooms.length === 0){
                $scope.resetInsurance();
                return false;
            }
            // ensure lead in is ok
            var earliestCheckin = moment($scope.cart.rooms[0].checkin);
            var duration = moment($scope.cart.rooms[0].checkout).diff(moment($scope.cart.rooms[0].checkin), 'days') + 1;
            angular.forEach($scope.cart.rooms, function($room){
                var currentCheckin = moment($room.checkin);
                var currentDuration = moment($room.checkout).diff(moment($room.checkin), 'days') + 1;
                if(currentCheckin.isBefore(earliestCheckin)){
                    earliestCheckin = currentCheckin;
                }
                if(currentDuration > duration){
                    duration = currentDuration;
                }
            });
            if(earliestCheckin.isAfter(moment().add($scope.property.insuranceMaxLeadMonths, 'months'))){
                $scope.resetInsurance();
                return false;
            }
            if(duration < $scope.property.insuranceMinDuration){
                $scope.resetInsurance();
                return false;
            }
            if(duration > $scope.property.insuranceMaxDuration){
                $scope.resetInsurance();
                return false;
            }
            return true;
        };

        $scope.getInsurancePremium = function(){
            var insurancePremium = $scope.getCartRoomTotal() * property.insuranceMultiplier;
            if(insurancePremium < $scope.property.insurancePremiumMinimum){
                return $scope.property.insurancePremiumMinimum;
            }
            return insurancePremium;
        };

        $scope.addPaxedRoomsToCart = function(){
            var
                adults = sessionFactory.selectedRoom.selectedAdults,
                children = sessionFactory.selectedRoom.selectedChildren,
                infants = sessionFactory.selectedRoom.selectedInfants,
                paxConfig = paxConfigurationCalculator.buildPaxConfiguration(adults,children,infants),
                maxPaxConfig = propertyFactory.rooms[sessionFactory.viewingRoom].maxPaxComponents,
                infantsTakeAvailability = propertyFactory.rooms[sessionFactory.viewingRoom].bookable.infantsTakeAvail,
                roomConfigs = paxConfigurationCalculator.getRoomConfiguration(paxConfig, maxPaxConfig, infantsTakeAvailability),
                roomCount = roomConfigs.length, room;

            for (room = 0; room < roomCount; room++) {
                $scope.pushPaxedRoomToCart(roomConfigs[room]);
            }
        };

        $scope.pushPaxedRoomToCart = function(roomPaxConfig){
            var room = {};
            room.id = sessionFactory.viewingRoom;
            room.paxConfig = {};
            room.paxConfig.adults = roomPaxConfig.adults;
            room.paxConfig.children = roomPaxConfig.children;
            room.paxConfig.infants = roomPaxConfig.infants;
            room.customValues = $.extend(true, {}, sessionFactory.selectedRoom.customValues);
            room.roomDetails = propertyFactory.rooms[sessionFactory.viewingRoom];
            room.pricing = propertyFactory.prices[sessionFactory.viewingRoom];
            room.checkin = sessionFactory.selectedFilters.checkin;
            room.checkout = sessionFactory.selectedFilters.checkout;
            room.nights = sessionFactory.selectedFilters.nights;
            room.mandatoryExtras = [];
            room.roomGroupIndex = sessionFactory.roomGroupIndex;

            cartFactory.rooms.push(room);

            // decrease the room count from the property
            propertyFactory.roomAvailabilities[sessionFactory.viewingRoom].availableRooms--;
        };

        $scope.roomsInRoomGroup = function(roomGroupIndex)
        {
            var count = 0;
            angular.forEach(cartFactory.rooms, function(room){
                if(room.roomGroupIndex ===  roomGroupIndex){
                    count++;
                }
            });
            return count;
        };

        ////

        function getCartRoomTotal() {
            var total = 0;
            // loop through the room priceing and
            for (var room = 0, rooms = cartFactory.rooms.length; room < rooms; room++) {
                // calculate only rooms that don't have any errors
                if (!cartFactory.rooms[room].hasError) {
                    var adults = cartFactory.rooms[room].paxConfig.adults;
                    var children = cartFactory.rooms[room].paxConfig.children;
                    var infants = cartFactory.rooms[room].paxConfig.infants;
                    var paxConfig = RoomRatePricing.buildPaxConfiguration(adults, children, infants);
                    var start = sessionFactory.selectedFilters.checkin;
                    var end = sessionFactory.selectedFilters.checkout;
                    var range = moment.range(start, end);
                    var period = 'nights';
                    var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(cartFactory.rooms[room].pricing, paxConfig, range, period);
                    total += priceOb.total;
                    // if the room has an extra add that to the amount too
                    // mandatory extras
                    for (var extra = 0, extras = cartFactory.rooms[room].mandatoryExtras.length; extra < extras; extra++) {
                        total += cartFactory.rooms[room].mandatoryExtras[extra].price;
                    }
                    // selected extras
                    for (var extra in cartFactory.rooms[room].selectedExtras) {
                        if (cartFactory.rooms[room].selectedExtras.hasOwnProperty(extra)) {
                            total += cartFactory.rooms[room].selectedExtras[extra].pricing.totalPrice;
                        }
                    }
                }
            }
            // add in any booking extras
            if(Array.isArray(cartFactory.extras)) {
                for (var bookingExtra = 0, bookingExtras = cartFactory.extras.length; bookingExtra < bookingExtras; bookingExtra++) {
                    total += cartFactory.extras[bookingExtra].price;
                }
            }
            // loop through user selected booking extras
            for (var selectedExtra in cartFactory.bookingExtras.selected) {
                if (cartFactory.bookingExtras.selected.hasOwnProperty(selectedExtra)) {
                    total += cartFactory.bookingExtras.selected[selectedExtra].pricing.totalPrice;
                }
            }
            return total;
        }

        // trigger google analytics page view
        function triggerTrackingPageView(pageUrl) {
            if ((typeof ga !== 'undefined')) {
                ga('send', 'pageview', {page: pageUrl});
            }
        }

        // trigger google analytics confirmation page view
        function triggerConfirmationTracking(transactions, items) {
            if (!(typeof ga === 'undefined')) {
                ga('require', 'ecommerce', 'ecommerce.js');
                // add transaction to google analytics
                for (var transaction in transactions) {
                    if (transactions.hasOwnProperty(transaction)) {
                        tran = transactions[transaction];
                        ga('ecommerce:addTransaction', {
                            "id": tran.id,
                            "affiliation": tran.affiliation,
                            "revenue": tran.revenue,
                            "tax": tran.tax,
                            "shipping": tran.shipping,
                            "city": tran.city,
                            "state": tran.state,
                            "country": tran.country
                        });
                    }
                }
                // add items to google analytics
                for (var item in items) {
                    if (items.hasOwnProperty(item)) {
                        itm = items[item];
                        ga('ecommerce:addItem', {
                            "id": itm.id,
                            "sku": itm.sku,
                            "price": itm.price,
                            "quantity": itm.quantity,
                            "name": itm.name,
                            "category": itm.category
                        });
                    }
                }
                // send the ecommerce event off
                ga('ecommerce:send');
                ga('send', 'pageview');
            }
        }

        function removeRoom(room, willReAdd) {
            // remove the room from the cart array and notify user using toast
            var removeRoomGroupIndex = cartFactory.rooms[room].roomGroupIndex,
                removedIndexes = [],
                roomId = cartFactory.rooms[room].id;

            willReAdd = willReAdd || false;

            angular.forEach(cartFactory.rooms, function(room, $index){
                if(room.roomGroupIndex === removeRoomGroupIndex){
                    removedIndexes.push($index);
                }
            });
            for (var i = 0, total = removedIndexes.length; i < total; i++) {
                // increase the room count
                propertyFactory.roomAvailabilities[roomId].availableRooms++;
                // remove the room from the cart
                delete cartFactory.rooms[removedIndexes[i]];
            }
            // Reindex:
            cartFactory.rooms = _.compact(cartFactory.rooms);

            if(cartFactory.rooms.length === 0){
                cartFactory.extras = [];
            }

            if (!willReAdd) {
                sessionFactory.toastMessage = 'Room removed from cart';
                sessionFactory.showToast = true;
                checkSelectedRoomsAreAvailable();
            }

            // update footer count
            setupStandardCartFooter();

            safeApply();
        }

        function getRoomInclExtrasTotal(room) {
            var roomPrice = getRoomInCartPrice(room);
            var extrasPrice = getRoomExtrasTotal(room);
            return roomPrice + extrasPrice;
        }

        function getRoomInCartPrice(room) {
            var roomUnderConsideration = cartFactory.rooms[room];
            var adults = roomUnderConsideration.paxConfig.adults;
            var children = roomUnderConsideration.paxConfig.children;
            var infants = roomUnderConsideration.paxConfig.infants;
            var paxConfig = RoomRatePricing.buildPaxConfiguration(adults, children, infants);
            var start = sessionFactory.selectedFilters.checkin;
            var end = sessionFactory.selectedFilters.checkout;
            var range = moment.range(start, end);
            var period = 'nights';
            var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(roomUnderConsideration.pricing, paxConfig, range, period);
            var roomTotal = priceOb.total;

            // if the room is a paxed rate we need to find the other rooms in the group and return the group price for all of them....
            if(cart.rooms[room].roomDetails.rate.isPaxRate){
                var groupId = cart.rooms[room].roomGroupIndex;
                roomTotal = 0; // reset
                angular.forEach(cart.rooms, function(room){
                    if(room.roomGroupIndex === groupId){
                        var paxConfig = RoomRatePricing.buildPaxConfiguration(room.paxConfig.adults, room.paxConfig.children, room.paxConfig.infants);
                        var priceOb = RoomRatePricing.getPerPeriodAndTotalPrice(room.pricing, paxConfig, range, period);
                        roomTotal += priceOb.total;
                    }
                });
            }

            return roomTotal;
        }

        function getRoomExtrasTotal(room) {
            var extras = cartFactory.rooms[room].mandatoryExtras;
            var total = 0;
            // add in mandatory extras pricing
            if (typeof extras !== 'undefined' && extras.length > 0) {
                for (extra in extras) {
                    if (extras.hasOwnProperty(extra)) {
                        total += extras[extra].price;
                    }
                }
            }

            // add in the prices for the extras attached to the room
            for (var extra in cartFactory.rooms[room].selectedExtras) {
                if (cartFactory.rooms[room].selectedExtras.hasOwnProperty(extra)) {
                    total += cartFactory.rooms[room].selectedExtras[extra].pricing.totalPrice;
                }
            }
            return total;
        }

        function getBookingLevelExtras() {
            var bookingExtras = [];
            for (var bookingExtra in cartFactory.bookingExtras.selected) {
                if (cartFactory.bookingExtras.selected.hasOwnProperty(bookingExtra)) {
                    var selectedExtra = cartFactory.bookingExtras.selected[bookingExtra],
                        customFields = {};
                    // Build custom fields value
                    angular.forEach(selectedExtra.customFields, function(customField){
                        customFields[customField.id] = {id: null, rawValue: null, value: customField.value};
                    });
                    var tmpExtra = {
                        categoryId: selectedExtra.extra.category.id,
                        extraId: selectedExtra.extra.id,
                        quantity: selectedExtra.quantity,
                        start: moment(selectedExtra.extraStart).format('YYYY-MM-DD'),
                        startTime: selectedExtra.startTime,
                        end: moment(selectedExtra.extraEnd).format('YYYY-MM-DD'),
                        endTime: selectedExtra.endTime,
                        adults: selectedExtra.paxConfig.adults,
                        children: selectedExtra.paxConfig.children,
                        infants: selectedExtra.paxConfig.infants,
                        paxDetails: selectedExtra.paxDetails,
                        customFields: customFields
                    };
                    bookingExtras.push(tmpExtra);
                }
            }
            return bookingExtras;
        }

        function getBookableReservationDetails () {
            var combos = [];
            for (var room in cartFactory.rooms) {
                if (cartFactory.rooms.hasOwnProperty(room)) {
                    var selectedRoom = cartFactory.rooms[room];
                    var combo = {};
                    combo.bookableId = propertyFactory.rooms[cartFactory.rooms[room].id].bookable.id;
                    combo.rateId = propertyFactory.rooms[cartFactory.rooms[room].id].rate.id;
                    combo.paxConfiguration = cartFactory.rooms[room].paxConfig;
                    combo.checkin = moment(sessionFactory.selectedFilters.checkin).format('YYYY-MM-DD HH:mm');
                    combo.checkout = moment(sessionFactory.selectedFilters.checkout).format('YYYY-MM-DD HH:mm');
                    combo.extras = [];
                    combo.groupId = cartFactory.rooms[room].roomGroupIndex;
                    // loop through the rooms extras
                    for (var extra in selectedRoom.selectedExtras) {
                        if (selectedRoom.selectedExtras.hasOwnProperty(extra)) {
                            var selectedExtra = selectedRoom.selectedExtras[extra],
                                customFields = {};
                            // Build custom fields value
                            angular.forEach(selectedExtra.customFields, function(customField){
                                customFields[customField.id] = {id: null, rawValue: null, value: customField.value};
                            });

                            var tempExtra = {
                                extraId: selectedExtra.extra.id,
                                categoryId: selectedExtra.extra.category.id,
                                quantity: selectedExtra.quantity,
                                start: moment(selectedExtra.extraStart).toString(),
                                end: moment(selectedExtra.extraEnd).toString(),
                                adults: selectedExtra.paxConfig.adults,
                                children: selectedExtra.paxConfig.children,
                                infants: selectedExtra.paxConfig.infants,
                                customFields: customFields
                            };
                            combo.extras.push(tempExtra);
                        }
                    }
                    combos.push(combo);
                }
            }
            return combos;
        }

        function checkSelectedRoomsAreAvailable() {
            var url = '/front-booking/api-check-rooms';
            if($scope.property.isItemOnly){
                url = '/front-booking/api-check-extras';
            }
            function callback(){};
            if(arguments.length > 0 && typeof arguments[0] === 'function'){
                callback = arguments[0];
            }
            // check cart has rooms
            if (getBookableReservationDetails().length > 0  || $scope.property.isItemOnly && $scope.getBookingLevelExtras().length > 0) {
                sessionFactory.isLoading = true;
                $http.post(url, {
                    bc: propertyFactory.id,
                    sid: sessionFactory.sid,
                    device: 'mobile',
                    templateID: propertyFactory.template.id,
                    bookableReservationDetails: getBookableReservationDetails(),
                    bookingExtras: getBookingLevelExtras(),
                    format: 'json'
                }).success(function (data, status, headers, config) {
                    var errors = false,
                        messages = [],
                        maxReservationsPerNight = data.maxRoomsPerNightReached;

                    // set eta listings for lead guest screen
                    $scope.property.availableETAs = data.availableETAs;

                    // set the max unique reached ids,
                    $scope.session.maxUniquenessReached = data.maxUniqueRoomRateReached;

                    // loop through the rooms
                    if(Array.isArray(data.rooms)) {
                        for (var room = 0, rooms = data.rooms.length; room < rooms; room++) {
                            // clear out previous errors
                            if(cart.rooms[room]) {
                                cart.rooms[room].hasError = false;
                                cart.rooms[room].errors = [];
                                cart.rooms[room].available = true;
                                cart.rooms[room].onRequest = false;
                                cart.rooms[room].mandatoryExtras = data.rooms[room].extras;
                            }
                            // check for availability issues
                            if (!data.rooms[room].available) {
                                var cartedRoom = cart.rooms[room];
                                if(maxReservationsPerNight) {
                                    cart.rooms.pop();
                                } else {
                                    angular.forEach(cart.rooms, function (roomObject, key) {
                                        if (roomObject.roomGroupIndex == room) {
                                            delete cart.rooms[key];
                                        }
                                    });
                                }
                                property.roomAvailabilities[cartedRoom.roomDetails.nonFilteredIndex] = 0;
                                session.forceRoomRefresh = true;
                                // cart.rooms[room].available = false;
                                // cart.rooms[room].hasError = true;
                                // cart.rooms[room].errors = data.rooms[room].messages;
                                errors = true;
                                //get the messages
                                for (var message = 1, messages = data.rooms[room].messages, messagesLen = messages.length; message < messagesLen; message++) {
                                    messages.push(messages[message - 1]);
                                }
                            } else {
                                // check is on request
                                if (data.rooms[room]['on-request']) {
                                    cart.rooms[room].onRequest = true;
                                }
                            }
                        }
                        // Using "delete" just sets the array entries to "undefined". This will remove those.
                        cart.rooms = _.compact(cart.rooms);
                    }
                    // add any mandatory booking extras
                    cartFactory.extras = data.extras;
                    // remove the loader
                    sessionFactory.isLoading = false;

                    // update availability - fbs dorm beds
                    if(data.hasOwnProperty('availabilityDifferences')){
                        var availabilityDifferences = data['availabilityDifferences'];
                        angular.forEach(property.rooms, function(room){
                            var datedAvailabilities = availabilityDifferences[room.bookable.id];
                            var lowestAvailability;
                            if(typeof datedAvailabilities === 'undefined'){
                                return true;
                            }
                            // get the smallest availability across all dates
                            angular.forEach(datedAvailabilities, function(availability){
                                if(typeof lowestAvailability === 'undefined'){
                                    lowestAvailability = availability;
                                }else {
                                    if(lowestAvailability > availability){
                                        lowestAvailability = availability;
                                    }
                                }
                            });
                            property.roomAvailabilities[room.nonFilteredIndex].availableRooms = property.roomAvailabilities[room.nonFilteredIndex].availableRooms < lowestAvailability ? property.roomAvailabilities[room.nonFilteredIndex].availableRooms : lowestAvailability;
                        });
                    }

                    // Get suggested Deposit
                    $scope.session.suggestedDeposit = data.suggestedDeposit;
                    $scope.session.paymentOptions   = data.paymentOptions;
                    $scope.session.hasPaymentGateway = data.hasPaymentGateway;
                    $scope.session.hasPaymentGatewayCapture = data.hasPaymentGatewayCapture;

                    // format the errors properly
                    var formattedErrorMessages = '<ul>';
                    for (message in messages) {
                        if (messages.hasOwnProperty(message)) {
                            formattedErrorMessages += '<li>' + messages[message] + '</li>';
                        }
                    }
                    formattedErrorMessages += '</ul>';
                    cartFactory.hasErrors = false;
                    // if there are any errors display them to the user
                    if (errors) {
                        cartFactory.hasErrors = true;
                        showError('Selection Unavailable', '<p>There was a problem with your selection</p>' +
                            '<div class="error-messages">' + formattedErrorMessages + '</div>' +
                            '<p>Please edit your selection.</p>' +
                            '', true);
                        $scope.proceedToLeadGuest = false;
                        // set the back button appropriately
                        $scope.footer.display.prev = false;
                        $scope.footer.display.next = false;
                        $scope.footer.mainContent = '<span class="glyphicon glyphicon-chevron-left"></span> Back';
                        goToRooms();

                    } else {
                        callback();
                    }

                }).error(function (data, status, headers, config) {
                    logError('Error pro', {status: status, headers: headers});
                    // display error to the user

                    // remove the loader
                    sessionFactory.isLoading = false;
                });
            }
        }

        function triggerAdWords() {
        }

        // used to ensure the min pax is met
        function checkPax() {
            if (sessionFactory.selectedRoom.selectedAdults === 0 && sessionFactory.selectedRoom.selectedChildren === 0 && sessionFactory.selectedRoom.selectedInfants === 0) {
                return false;
            }
            else {
                return true;
            }
        }

        function showToast(message) {
            sessionFactory.showToast = true;
            sessionFactory.toastMessage = message;
        }

        function showError(title, message, show) {
            sessionFactory.errorHandler.errorTitle = title;
            sessionFactory.errorHandler.message = message;
            sessionFactory.errorHandler.showError = show;
            safeApply();
        }

        function safeApply(fn) {
            if(this.$root && typeof this.$root !== 'undefined') {
                var phase = this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof(fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            }
        }

        function goToRooms() {
            sessionFactory.loadingWarning.show = false;
            sessionFactory.loadingWarning.warning = null;
            goToPage('rooms');
            safeApply();
        }

        function reloadApp() {
            // display the loader
            sessionFactory.isLoading = true;
            // reload the page - controller will automatically redirect on reload
            window.location.reload();
        }

        function goToCart() {
            if (cartFactory.rooms.length > 0 || propertyFactory.isItemOnly) {
                goToPage('cart', $location, $scope);
            }
        }

        function goToPage(page) {
            $location.path(page);
        }

        function goBack() {
            sessionFactory.loadingWarning.show = false;
            sessionFactory.loadingWarning.warning = null;
            window.history.back(-1);
            $scope.safeApply();
        }

        function setupStandardCartFooter() {
            $scope.footer.prevFunc = standardPrevFunc;
            $scope.footer.mainFunc = standardMainFunc;
            $scope.footer.display.prev = true;
            $scope.footer.display.main = true;
            $scope.footer.display.next = true;
            $scope.footer.mainContent = '<span class="badge cart-count"><span class="glyphicon glyphicon-shopping-cart"></span>' + cartFactory.getPaxDelimitedRooms() + '</span> in cart';
            if (cartFactory.rooms.length <= 0) {
                $scope.footer.disabled.next = true;
            }
            ////
            function standardPrevFunc() {
                goBack();
            }

            function standardMainFunc() {
                goToPage('cart');
            }
        }

        // setup switch to desktop link with room filters if there are any
        function roomsFilterHref() {
            if (sessionFactory.filterRooms.length > 0) {
                var key = '&rmtype=';
                angular.forEach(sessionFactory.filterRooms, function (room) {
                    key += room + ',';
                });
                return key;
            }
        }

        function nextFunc() {
        }

        function prevFunc() {
        }

        function mainFunc() {
            findRooms('rooms');
        }

        function findRooms(view) {
            switch (view) {
                case 'rooms':
                    appFactory.controls.type = 'cart-forwards';
                    break;
            }
            $location.path(view);
        }

        // application wide error logging
        function logError(message, extraFields) {
            if (typeof sentryDSN !== 'undefined') {
                if (!Raven.isSetup()) {
                    Raven.config(sentryDSN).install();
                }
                extraFields.sessionId = sid;
                extraFields.propertyId = propertyId;

                Raven.captureMessage(message, {tags: extraFields});
            }
        }

        // watcher for rooms added to cart
        $scope.$watch('cart.rooms', function (newVal) {
            // check rooms in cart and update navigation accordingly.
            if (cartFactory.rooms.length > 0) {
                $scope.footer.disabled.next = false;
            } else {
                $scope.footer.disabled.next = true;
            }
        }, true);

        $scope.$on('$routeChangeSuccess', function (event, current, next) {
            // check if a booking has already been made and reload the page if the user is trying to history back to a previous page
            // this will cause the application to reload completely.
            sessionFactory.locationPath = $location.path();
            if (sessionFactory.bookingMade) {
                reloadApp();
            }

            var pageUrl = $location.url();
            if(typeof current !== 'undefined' && typeof current.$$route !== 'undefined') {
                document.title = current.$$route.title;
                pageUrl = current.$$route.originalPath;
            }
            // call the google analytics page view
            triggerTrackingPageView(pageUrl);
        });


        $scope.getPricing = function (prices, adults, children, infants) {
            return pricing(prices, adults, children, infants);
        };



        // watch for updates to the currency and update conversions accordingly
        $scope.$watch('session.selectedFilters.currency', updateConversions, true);

        // check the rooms and if there are none, then redirect user to the filters screen. Incase of bookmarked page directs
        if (propertyFactory.rooms) {
            if (typeof ngInTesting !== 'undefined' && !ngInTesting) {
                $scope.goToPage('#');
            }
        }






        // Force the bad browser warning to show if we detect we can't support it
        if (window.operamini) {
            sessionFactory.badBrowser = true;
            sessionFactory.isLoading = true;
        }
    });

var updateConversions = function () {
    fx.base = currencies.base;
    fx.rates = currencies.rates;
    fx.settings.from = defaultCurrency;
    fx.settings.to = session.selectedFilters.currency;
};

//var findRooms = function(view,$location, $scope){
//    switch(view){
//        case 'rooms':
//            $scope.baseApp.controls.type = 'cart-forwards';
//            break;
//    }
//    $location.path(view);
//};

//var goToPage = function(page, $location, $scope){
//    $location.path(page);
//};

var pricing = function (prices, adults, children, infants) {
    //var prices = getTestingArray()[0];
    var price = getPrice(prices, adults, children, infants);
    return price;
};

if(typeof $ !== 'undefined') {
    $('body').on('touchstart', function (e) {
        if (e.originalEvent.touches.length != 1) {
            return;
        }
        lastTouchY = e.originalEvent.touches[0].clientY;
        preventPullToRefresh = window.pageYOffset == 0;
    });

    $('body').on('touchmove', function (e) {
        var touchY = e.originalEvent.touches[0].clientY;
        var touchYDelta = touchY - lastTouchY;
        lastTouchY = touchY;
        if (preventPullToRefresh) {
            // To suppress pull-to-refresh it is sufficient to preventDefault the first overscrolling touchmove.
            preventPullToRefresh = false;
            if (touchYDelta > 0) {
                e.preventDefault();
                return;
            }
        }
    });
}

if (typeof Modernizr !== 'undefined' && Modernizr.touch) {
    var $body = $('body');

    $(document)
        .on('focus', 'input, select, textarea', function () {
            $body.addClass('fixfixed');
        })
        .on('blur', 'input, select, textarea', function () {
            $body.removeClass('fixfixed');
        });
}
